import React, { ButtonHTMLAttributes, useEffect, useState } from 'react';
import { FaStar, FaThumbsUp } from 'react-icons/fa';
import { useInteraction } from '../../../../hooks/Interactions';
import { FavoriteDiv } from './styles';
interface IProps {
  type: string;
  subtype: string;
  button?: boolean;
  id: string | number;
  addCallback?: Function;
};

/*
  hook => interactions
*/

const Favorite: React.FC<IProps> = ({ type, subtype, id, addCallback = () => { }, button = false }) => {

  const { interactions, addInteraction } = useInteraction();

  const [active, setActive] = useState(false);


  useEffect(() => {


    const isActive = interactions && interactions[type] && interactions[type][id] && interactions[type][id][subtype] ? true : false;

    setActive(isActive);


  }, [type, subtype, id])



  const interactionRef = {
    star: { render: () => <FavoriteDiv onClick={() => { setActive(!active); addInteraction({ type, subtype, id, value: 1 }); addCallback() }}><FaStar style={{ color: active ? 'yellow' : '#fff' }} /></FavoriteDiv> },
    thumb: { render: () => button ? <button className='defaultButton' style={{ padding: '5px 10px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 'auto', minWidth: 'auto' }} onClick={() => { setActive(!active); addInteraction({ type, subtype, id, value: 1 }); addCallback() }}><FavoriteDiv ><FaThumbsUp style={{ color: active ? 'yellow' : '#fff' }} /></FavoriteDiv> <p style={{ marginLeft: '10px', color: '#fff' }}> Curtir</p></button> : <FavoriteDiv onClick={() => { setActive(!active); addInteraction({ type, subtype, id, value: 1 }); addCallback() }}><FaThumbsUp style={{ color: active ? 'yellow' : '#fff' }} /></FavoriteDiv> }

  }

  return interactionRef[subtype] ? <div style={{ width: '20px' }}>{interactionRef[subtype].render()}</div> : <></>;
};

export default Favorite;
